import React from 'react'

import { Heading6, Text, Space } from '@gousto-internal/citrus-react'

type SectionHeaderProps = {
  title: string
  subtitle?: string
}

export const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => (
  <>
    <Heading6>{title}</Heading6>
    {subtitle && <Text size={1}>{subtitle}</Text>}
    <Space size={[3, 6]} />
  </>
)
